"use strict";
(self["webpackChunktom_bihn"] = self["webpackChunktom_bihn"] || []).push([[847],{

/***/ 847:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ productPage)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _accessible360_accessible_slick__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(475);
/* harmony import */ var _accessible360_accessible_slick__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_accessible360_accessible_slick__WEBPACK_IMPORTED_MODULE_1__);


// +++++++++++++++++++++
// Product
// +++++++++++++++++++++

// data-component="product/product"

function productPage({ wrapper }) {
  var settings = {
    // good candidate for component - productImages.
    productImages: '.js-product-slider',
    // Chris todo: remove this js-product-price and utilize 'product-price.js'
    productPrice: '.js-product-price',
    moneyFormat: '${{ amount }}', // product-price
    radioVariantInput: '[data-hook="product-option"]',
    shippingMessage: '.js-shipping-message',
    atc: '.js-add-to-cart',
    stickyPrice: jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-sticky-price'),
    stickyAtcText: '.js-sticky-add-to-cart-text',
    stickyAtc: '.js-sticky-atc',
    backToTop: '.js-back-to-top',
    reviewStars: '.js-okeReviews-reviewsSummary',
    navigationLink: '.js-product-nav-link',
  }

  const cache = {
    product: {},
    variant: {},
  }

  var init = function () {
    initializeEventListeners()
    initSliders()

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.radioVariantInput).filter(':checked').trigger('change')

    initializeLinkObserver()
  }

  var config = {
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    focusOnSelect: true,
    infinite: false,
    dots: true,
    speed: 100,
    adaptiveHeight: window.screen.availWidth <= 768,
  }

  var initSliders = function () {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.productImages).slick(config)
  }

  var variantChangeFromOptions = function (event, { variant, product, isUpsell }) {
    if (isUpsell) return

    if (product) {
      cache.product = product
    }

    if (variant) {
      cache.variant = variant

      updateUrlParam(variant) // buy-panel.js
      updateShippingMessage(variant)
      updatePrice(variant) // product-price.js
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-sticky-product-variant').text(variant.title)

      if (variant.sku) {
        filterImages(variant.sku)
      }
    } else {
      updateShippingMessage()
    }
  }

  var updateUrlParam = function (variant) {
    // Chris todo: remove this function and set-up buy-panel.js data-component
    var currentParams = location.search

    if (currentParams.match(/variant=\d*/)) {
      var newParams = currentParams.replace(/variant=\d*/, 'variant=' + variant.id)
    } else {
      var newParams = '?variant=' + variant.id
    }

    // @arren need solution for not adding a bunch of vriants to the history obj.
    history.replaceState({}, '', location.pathname + newParams)
  }

  // var updateAtcLabel = function()

  var updateShippingMessage = function (variant, option) {
    // also updates the ADD TO CART button
    // TODO: leverage liquid messaging from 'snippets/product-scripts.liquid'
    // so that we can de-couple the logic that lives in this function to essentially:

    // if (variant.available)
    // else if (variant.status === 'InP')
    // else variant is OOS

    var $atc = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.atc)
    var $stickyAtc = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.stickyAtc)
    var $stickyAtcText = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.stickyAtcText)

    if (!variant) {
      let shippingMessageNote = "Hi there! This size or color isn't currently in production."

      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.shippingMessage)
        .show()
        .html(shippingMessageNote)
        .addClass('out-of-stock')
        .removeClass('in-production in-stock')
      $atc.text('Out of Stock').attr('disabled', true)
      $stickyAtcText.text('Out of Stock')
      $stickyAtc.attr('disabled', true)
    } else {
      let variantInventoryStatus = customVariantStatus[variant.id]
      let shippingMessageNote = customCartMsgs[variant.id]

      if (variant.available) {
        // @AA inproduction notes
        // =====================
        if (shippingMessageNote) {
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.shippingMessage)
            .show()
            .html(shippingMessageNote)
            .addClass('in-production')
            .removeClass('in-stock out-of-stock')
        } else {
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.shippingMessage).hide()
        }

        if (cache.product.tags.includes('preorder')) {
          $atc.text('Pre-Order').attr('disabled', false)
          $stickyAtcText.text('Pre-Order')
          $stickyAtc.attr('disabled', false)
        } else {
          $atc.text('Add To Cart').attr('disabled', false)
          $stickyAtcText.text('Add To Cart')
          $stickyAtc.attr('disabled', false)
        }
      } else {
        // variant is OOS
        if (
          variant.inventory_quantity <= 0 &&
          variant.inventory_quantity > -100 &&
          variantInventoryStatus != 'In Production' &&
          variantInventoryStatus != 'In Production_forced'
        ) {
          $atc.text('Out of Stock').attr('disabled', true)
          $stickyAtcText.text('Out of Stock')
          $stickyAtc.attr('disabled', true)
          // out of stock
          if (jquery__WEBPACK_IMPORTED_MODULE_0___default().inArray(variant.sku, base_production_variants) >= 0) {
            shippingMessageNote =
              "We'll be making this bag in our Seattle factory soon, and we’ll update this notice when we have an estimate as to when it will be ready to ship."
          } else {
            var stockText = 'Unavailable'
            shippingMessageNote = "Hi there! This size or color isn't currently in production."
          }

          if (shippingMessageNote) {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.shippingMessage)
              .show()
              .html(shippingMessageNote)
              .addClass('out-of-stock')
              .removeClass('in-production in-stock')
          } else {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.shippingMessage).hide()
          }
        } else {
          // in production
          $atc.text('Next Batch').attr('disabled', true)
          $stickyAtcText.text('Next Batch')
          $stickyAtc.attr('disabled', true)

          if (variant.sku.indexOf('PXXX') == 0 || variant.sku.indexOf('TB05XXX') == 0) {
            shippingMessageNote = 'More of these are on the way and we expect them to be available for order soon!'
          } else {
            if (custom_production_msg.hasOwnProperty(variant.sku)) {
              shippingMessageNote = custom_production_msg[variant.sku]
            } else {
              shippingMessageNote =
                "We're making this bag in our Seattle factory and expect it to be available for order within the next 2 - 12 weeks."
            }
          }

          if (shippingMessageNote) {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.shippingMessage)
              .show()
              .html(shippingMessageNote)
              .addClass('in-production')
              .removeClass('in-stock out-of-stock')
          } else {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.shippingMessage).hide()
          }
        }
      }
    }
  }

  let filterImages = function (sku) {
    let $slider = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.productImages)

    let interval = setInterval(function () {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('slickUnfilter')
        $slider.slick('slickFilter', function (index, slide) {
          let $slide = jquery__WEBPACK_IMPORTED_MODULE_0___default()(slide).find('img')
          let colorData = $slide.data('colors')
          // return true;
          return colorData.includes(sku)
        })

        $slider.slick('slickGoTo', 0, true)

        if ($slider.find('img').length === 0) {
          $slider.slick('slickUnfilter')
        }
        clearInterval(interval)
      }
    }, 100)
  }

  var updatePrice = function (variant) {
    // product-price.js
    var formattedPrice = formatMoney(variant.price, settings.moneyFormat)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.productPrice).text(formattedPrice)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.stickyPrice).text(formattedPrice)
  }

  var handleProductPageScroll = function () {
    // Back To Top Button
    if (window.scrollY > 600) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.backToTop).fadeIn(200)
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.backToTop).fadeOut(200)
    }
  }

  var observeLinks = function (entries, observer) {
    var activeEntry = entries[0]

    if (activeEntry.isIntersecting) {
      var id = activeEntry.target.id

      var $activeLink = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.navigationLink).closest('[data-link="' + id + '"]')

      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.navigationLink).not($activeLink).removeClass('active')
      $activeLink.addClass('active')
    }
  }

  var scrollToReviews = function (e) {
    e.preventDefault()

    if (typeof okendoReviews !== 'undefined') {
      setTimeout(function () {
        document.getElementById('reviews').scrollIntoView()
      }, 1000)
    } else {
      document.getElementById('reviews').scrollIntoView()
    }
  }

  var initializeLinkObserver = function () {
    // Product Navigation Active / Inactive links
    let options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    }

    let observer = new IntersectionObserver(observeLinks, options)

    let $targets = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.product-nav-target')

    $targets.each(function (index, target) {
      observer.observe(target)
    })
  }

  var initializeEventListeners = function () {
    // scrollToReviews, listen for variant change from product-options
    // everything else we can keep
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', settings.reviewStars, scrollToReviews)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('scroll', handleProductPageScroll)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('variant-selector:change', variantChangeFromOptions)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('variant-selector:request')
  }
  init()
}


/***/ })

}]);